
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


// Vue
import Vue from 'vue';

// Axios
window.axios = require('axios');

// Components
import MapComponent from './pages/map/MapComponent.vue';


import "leaflet/dist/leaflet.css";


var vm = new Vue({
    el: "#app",
    components : {
        'lc-map' : MapComponent
    }
});


global.vm = vm;